import { API_CONSULT } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function getFiles(params, isLoadMore) {
  return {
    types: [
      ACTION_TYPES.FILES_GET_REQUESTED,
      ACTION_TYPES.FILES_GET_SUCCEED,
      ACTION_TYPES.FILES_GET_FAILED,
    ],
    promise: client => client.get(`/messages/files`, { params }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      isLoadMore,
    },
  };
}
